
  import { computed, defineComponent, provide } from "vue"
  import "./scss/leftPanel/LeftPanel.scss"

  import Profile from "./Profile.vue"
  import ThemeSwitcher from "../app/ThemeSwitcher.vue"
  import ExportWords from "./ExportWords.vue"
  import CreateFolder from "../folders/CreateFolder.vue"
  import { useStore } from "vuex"
  import ImportWords from "./ImportWords.vue"
  import ScannerWords from "../app/ScannerWords.vue"

  export default defineComponent({
    name: "AccountLeft",
    components: {
      Profile,
      CreateFolder,
      ExportWords,
      ThemeSwitcher,
      ImportWords,
      ScannerWords
    },
    inject: ["Ti18N"],
    setup() {
      const store = useStore()
      const profile = computed(() => store.getters.profileOtherUser)
      const wordsLength = computed(() => store.getters.wordsLength)
      const isMyUser = computed(() => store.getters.isMyUser)

      provide("isMyUser", isMyUser.value)

      return { profile, wordsLength, isMyUser }
    }
  })
